import Base from './base'
import axios from "axios";
axios.defaults.withCredentials = true

//登录
class Login extends Base {
  //登录
  static async login(data) {
    super.deleteCache('ss_initData')
    let remember = $tool.getCookie('remember_me')
    if (remember == 'Y' && !data.alp) { //7天内自动登录
      data.chkpersist = 1
    }
    // /** 临时调整 修复参数配置 */
    // try{
    //   if(new URL(location.href).searchParams.get('_outParamKey')){
    //     data.outParamKey = new URL(location.href).searchParams.get('_outParamKey')
    //   }
    // }catch(e){
    //   console.log(e)
    // }
    // 登录passport
    // let res = await super.get('/jsonp/login2.json', data, {baseURL: $ZConfig.getPassportUrl()})

    let res = await axios.get('/jsonp/login2.json', {
      baseURL: $ZConfig.getPassportUrl(),
      params: data,
      timeout: 20000,
      withCredentials: true
    })
    if (res.data.code != '0') {
      return res.data
    }
    // 无权访问其他页面登出时清空
    localStorage.removeItem('hideMenu')
    // 注入应用服务器信息
    let resReg = await this.regMyLogin(res.data.clientKey)
    return resReg
  }
  // 注入应用服务器登录信息
  static async regMyLogin(KI4SO_CLIENT_EC) {
    let resClient = await axios.get('login.json?KI4SO_CLIENT_EC=' + KI4SO_CLIENT_EC,  {baseURL: $ZConfig.getServerUrl(), withCredentials: true})
    if (resClient.data.code != '0') {
      return resClient.data
    }
    let resConfig = await new Promise(resolve => {
      $ZConfig.reload(function () {
        resolve({code: '0'})
      })
    })
    return resConfig
  }

  //退出
  static out() {
    super.deleteCache('ss_initData')
    sessionStorage.removeItem('_logined')
    // 无权访问其他页面登出时清空, 为了避免客服不理解退出操作直接关闭窗口
    if (localStorage.getItem('hideMenu')) {
      console.log('222')
      localStorage.removeItem('hideMenu')
      window.close()
      return
    }
    $jump.to('/logout')
  }

  //切换企业
  static async changeUser(userId, success, fail) {
    super.deleteCache('ss_initData')
    localStorage.clear()
    let url = '/api/pp/common/specialLogin.json'
    let remember = $tool.getCookie('remember_me')

    if (userId) {
      url += `?userId=${userId}`
      if (remember == 'Y') { //7天内自动登录
        url += '&chkpersist=1'
      }
    }
    console.log(url, 'url')
    let rs = await super.get(url)
    if (rs.data.code != '0') {
      return rs
    }
    let data = rs.data.data
    // 先退出
    if (data.logoutUrl) {
      data.logoutUrl.split(',').forEach(url => {
        new Image().src = url
      })
    }
    let res = await this.login({
      alp: data.alp,
      loginType: 'alp'
    })
    console.log(res,  888888)
    return res
  }

  //自动登录
  static loginIfNotLogined(cb, alp) {
    async function login() {
      let res = await Login.login({alp, loginType: alp ? 'alp' : 'auto'})
      if (res.code == '0') {
        if ($tool.getCookie('gray_env') == 1) {
          window.location.reload()
          return
        }
        cb(res)
      } else {
        $jump.toLogin()
      }
    }

    async function getInitData() {
      let res = await Base.get('/api/pp/common/platform/home/initData.json', null, {
        cacheKey: 'ss_initData',
        force: true
      })
      if (res.code == -99) {
        login()
      }else{
        cb()
      }
    }
    alp ? login() : getInitData()
  }

  /**
   * 接入飞书登陆后逻辑
   */
  static async thirdAfterLogin() {
    console.log('飞书登录后逻辑')
    let externalCode = window.localStorage.getItem('externalCode')
    let tenantCode = window.localStorage.getItem('tenantCode')
    let channelType = window.localStorage.getItem('channelType')
    if (window.localStorage.getItem('hasFeiShuCode') === '1' && externalCode && tenantCode && channelType) {
      let feiSThirdParams = {
        externalCode: externalCode,
        tenantCode: tenantCode,
        channelType: channelType
      }
      window.localStorage.setItem('hasFeiShuCode', '0')
      let res =  await Base.post(`it/channel/afterLogin`, feiSThirdParams)
      if (res.code === '0') {
        console.log('飞书登录成功')
      } else {
        console.log('飞书登录失败')
      }
    }

  }
}

export default Login
